<template>
    <v-container id="register" class="fill-height" tag="section">
        <v-row justify="center" no-gutters>
            <v-slide-y-transition appear>
                <base-material-card
                    id="auth"
                    color="#0051ff"
                    light
                    max-width="100%"
                    width="400"
                    class="px-5 pb-2 py-3 auth-card"
                >
                    <template v-slot:heading>
                        <div class="text-center">
                            <h1 class="display-2 font-weight-bold">Регистрация нового пользователя</h1>
                        </div>
                    </template>

                    <v-snackbar
                        v-model="snackbar"
                        class="register-snakbar"
                        absolute
                        top
                        :color="snackbarColor"
                        :timeout="timeout = 5000"
                    >
                        <span>{{ responseMessage }}</span>
                        <v-icon dark>mdi-checkbox-marked-circle</v-icon>
                    </v-snackbar>
                    <form>
                        <!-- ИМЯ -->
                        <v-col cols="12" class="pb-0">
                            <v-text-field
                                v-model="name"
                                v-validate="'required|alpha_dash'"
                                :error-messages="errors.collect('name')"
                                label="Ваше имя"
                                data-vv-name="name"
                                validate-on-blur
                                required
                                color="purple darken-2"
                                clearable
                                prepend-icon="mdi-account-tie"
                            />
                        </v-col>
                        <!-- Email -->
                        <v-col cols="12" class="py-0">
                            <v-text-field
                                v-model="email"
                                v-validate="'required|email'"
                                :error-messages="errors.collect('email')"
                                label="E-mail"
                                color="purple darken-2"
                                data-vv-name="email"
                                prepend-icon="mdi-email"
                                clearable
                                validate-on-blur
                                required
                            />
                        </v-col>
                        <!-- ТЕЛЕФОН -->
                        <v-col cols="12" class="py-0">
                            <v-text-field
                                v-model="phone"
                                v-validate="'required|min:12'"
                                v-mask="mask"
                                prepend-icon="mdi-phone"
                                type="text"
                                :error-messages="errors.collect('phone')"
                                label="Номер телефона"
                                color="purple darken-2"
                                data-vv-name="phone"
                                class="input-group--focused"
                                required
                                hint="введите номер в формате +38... или +7..."
                                validate-on-blur
                                clearable
                            />
                        </v-col>
                        <!-- ПАРОЛЬ -->
                        <v-col cols="12" class="py-0">
                            <v-text-field
                                ref="regPass"
                                v-model="regPass"
                                v-validate="'required|min:6'"
                                prepend-icon="mdi-lock-outline"
                                :append-icon="showPass ? 'visibility' : 'visibility_off'"
                                :type="showPass ? 'text' : 'password'"
                                :error-messages="errors.collect('regPass')"
                                label="Пароль..."
                                data-vv-name="regPass"
                                class="input-group--focused"
                                validate-on-blur
                                color="purple darken-2"
                                @click:append="showPass = !showPass"
                            />
                        </v-col>
                        <!-- ПОДТВЕРДИТЬ ПАРОЛЬ -->
                        <v-col cols="12" class="py-0">
                            <v-text-field
                                v-model="regPassConfirm"
                                v-validate="'required|confirmed:regPass'"
                                prepend-icon="mdi-lock-outline"
                                :append-icon="showPassConfirm ? 'visibility' : 'visibility_off'"
                                :type="showPassConfirm ? 'text' : 'password'"
                                :error-messages="errors.collect('regPassConfirm')"
                                label="Подтвердите пароль..."
                                data-vv-name="regPassConfirm"
                                data-vv-as="password"
                                class="input-group--focused"
                                validate-on-blur
                                color="purple darken-2"
                                @click:append="showPassConfirm = !showPassConfirm"
                            />
                        </v-col>
                        <v-col cols="12" class="py-0 my-4 text-center">
                            <v-btn
                                class="mr-0"
                                color="#0051ff"
                                @click="submit"
                                :disabled="disabledSubmitButton"
                            >Регистрация</v-btn>
                        </v-col>
                        <!-- Соглашение -->
                        <v-col cols="12">
                            <div class="text-center title" @click.stop>
                                Регистрируясь, вы подтверждаете, что принимаете
                                <a
                                    href="javascript:;"
                                    class="purple--text"
                                    @click.stop="terms = true"
                                >Пользовательское соглашение</a>
                                и соглашаетесь с
                                <a
                                    href="javascript:;"
                                    class="purple--text"
                                    @click.stop="conditions = true"
                                >Политикой конфиденциальности.</a>
                            </div>
                        </v-col>
                    </form>
                    <v-dialog v-model="terms" width="70%" class="terms" light>
                        <v-card>
                            <v-card-title class="headline">Пользовательское соглашение</v-card-title>
                            <v-card-text v-for="n in 5" :key="n">{{ content }}</v-card-text>
                            <v-card-actions>
                                <v-spacer />
                                <v-btn text color="purple" @click="terms = false">Ok</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="conditions" width="70%" class="privacy-policy" light>
                        <v-card>
                            <v-card-title class="headline">Политика конфиденциальности</v-card-title>
                            <v-card-text v-for="n in 5" :key="n">{{ content }}</v-card-text>
                            <v-card-actions>
                                <v-spacer />
                                <v-btn text color="purple" @click="conditions = false">Ok</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </base-material-card>
            </v-slide-y-transition>
        </v-row>
    </v-container>
</template>

<script>
    import { mask } from "vue-the-mask";
    import { ApiService } from "../../service/api/ApiService";

    export default {
        $_veeValidate: {
            validator: "new"
        },
        name: "PagesRegister",
        directives: {
            mask
        },
        data: () => ({
            name: "",
            email: "",
            phone: "",
            regPass: "",
            regPassConfirm: "",
            responseMessage:
                "Регистрация успешна, письмо для подтверждения отправлено Вам на почту.",
            dictionary: {
                attributes: {
                    email: "E-mail Address"
                    // custom attributes
                },
                custom: {
                    name: {
                        required: () => "Введите имя",
                        alpha_dash: "Только буквы и цифры"
                        // custom messages
                    },
                    email: {
                        required: "Введите email",
                        email: "Невалидный email"
                    },
                    phone: {
                        required: "Введите номер телефона",
                        min: "Минимум 12 символов"
                    },
                    regPass: {
                        required: "Введите пароль",
                        min: "Минимум 6 символов"
                    },
                    regPassConfirm: {
                        required: "Введите пароль",
                        confirmed: "Пароли не совпадают"
                    },
                    checkbox: {
                        required: "Введите пароль"
                    }
                }
            },

            mask: "+############",
            value: "+",
            checkbox: false,
            lazy: false,
            conditions: false,
            content: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris. Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Curabitur sodales ligula in libero. Sed dignissim lacinia nunc.`,
            snackbar: false,
            snackbarColor: "success",
            terms: false,
            showPass: false,
            showPassConfirm: false,
            disabledSubmitButton: false
        }),
        mounted() {
            this.$validator.localize("en", this.dictionary);
        },

        methods: {
            async submit() {
                const isValid = await this.$validator.validate();
                if (!isValid) {
                    return;
                }
                this.disabledSubmitButton = true;

                const formData = {
                    phone_number: this.phone,
                    first_name: this.name,
                    password_confirmation: this.regPassConfirm,
                    password: this.regPass,
                    email: this.email
                };
                ApiService.post("register", formData)
                    .then(() => {
                        this.snackbarColor = "success";
                        this.snackbar = true;
                    })
                    .catch(error => {
                        this.snackbarColor = "error";
                        this.snackbar = true;
                        this.responseMessage =
                            error.response.data.message +
                            " " +
                            Object.values(error.response.data.errors).join(",");
                    })
                    .finally(() => {
                        this.disabledSubmitButton = false;
                    });
            },
            clear() {
                this.name = "";
                this.email = "";
                this.phone = "";
                this.regPass = "";
                this.regPassConfirm = "";
                this.$validator.reset();
            }
        }
    };
</script>

<style lang="scss">
    #register {
        .v-list-item__subtitle {
            -webkic-line-clamp: initial;
            -webkit-box-orient: initial;
        }

        .v-snack.register-snakbar.v-snack--active.v-snack--absolute.v-snack--top {
            top: calc(50% - 80px);
            padding: 20px;
            line-height: 30px;
        }

        .register-checkbox {
            .v-input__slot {
                display: flex;
                align-items: flex-start;
            }
        }

        .text-center.title {
            font-size: 0.8rem !important;
            font-weight: 500;
            line-height: 1rem;
            letter-spacing: 0.0125em !important;
            font-family: "Roboto", sans-serif !important;
        }
    }
</style>
